import { render, staticRenderFns } from "./OmdService.vue?vue&type=template&id=233a3cb9&scoped=true"
var script = {}
import style0 from "./OmdService.vue?vue&type=style&index=0&id=233a3cb9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "233a3cb9",
  null
  
)

export default component.exports